import { TransformableInterface, TransformerOptions } from './common';
import { ClassTransformOptions, instanceToPlain } from 'class-transformer';
import { excludePropsHelper } from './helpers';

/**
 * @class
 * @description Create new plain Object copy props from data to it using class-transformer lib
 */
export class ToPlainTransformer implements TransformableInterface {
    transform(data: any, options: ClassTransformOptions & TransformerOptions = {}): any {
        return excludePropsHelper(instanceToPlain(data, {...options, enableCircularCheck: true }), options.exclude);
    }
}
